import React, { useEffect, useState } from 'react';
import imagbtns from '../../images/brand/uploadimg.svg';
import { Button, Col, ColorPicker, Form, Input, Row, Select, Tooltip, message } from 'antd';
// import { businessCategories, updatedBusinessServiceList } from '@utils/contstant';
import { CopyOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import DynamicInputBox from '@components/Comman/DynamicInputBox';
import { commaSeparatedString } from '@utils/comman';

interface Subcategory {
    label: string;
    value: string;
  }
  
  interface BusinessCategory {
    label: string;
    value: string;
    subcategories: Subcategory[];
  }
  
  interface Props {
    businessCategories: BusinessCategory[];
    handleCategoryChange: (value: string) => void;
  }

const { TextArea } = Input;

export const Basicinfo = ({ businessInfo, setBusinessInfo, handleSubmit }: any) => {
    const [form] = Form.useForm();
    // const dispatch = useDispatch();
    const user = useSelector((state: any) => state?.Auth);
    let userData = user?.user?.data || user?.user?.user;
    const [isOtherSelected, setIsOtherSelected] = useState(false);
    const [profilePic, setProfilePic] = useState<any>(businessInfo?.logoUrl);
    const [profileFile, setProfileFile] = useState<any>(businessInfo?.profilePic);
    const [bannerPic, setBannerPic] = useState<any>(businessInfo?.bannerPic);
    const [bannerFile, setBannerFile] = useState<any>(businessInfo?.bannerPic);
    const [servicesValue, setServicesValue] = useState<any>(businessInfo?.services?.split(', ')?.map((item: any) =>{ return { value: item}}) || [])
    const { businessCategory } = useSelector((state: any) => state?.Business)

    const handleImageChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        imageType: 'profile' | 'banner'
    ) => {
        event.preventDefault();
        const file = event.target.files?.[0];
        if (file) {
            const maxSize = 1 * 1024 * 1024; // 1 MB limit
            if (file.size > maxSize) {
                message.error('File size should not exceed 1 MB.');
                return;
            }

            if (!file.type.startsWith('image/')) {
                message.error('Please upload a valid image.');
                return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                if (imageType === 'profile') {
                    setProfileFile(file);
                    setProfilePic(reader.result);
                    // setBusinessInfo({ ...businessInfo, profilePic: reader.result });
                    localStorage.setItem("logo", JSON.stringify(reader.result));
                } else if (imageType === 'banner') {
                    setBannerFile(file);
                    localStorage.setItem("banner", JSON.stringify(reader.result));
                    setBannerPic(reader.result);
                    // setBusinessInfo({ ...businessInfo, bannerPic: reader.result});
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setBusinessInfo({
            ...businessInfo,
            [name]: value,
        });
    };

    const triggerFileUpload = (imageType: 'profile' | 'banner') => {
        const fileInputId = 'file-upload-profile';
        const fileInput = document.getElementById(fileInputId) as HTMLInputElement;
        if (fileInput) {
            fileInput.click();
        }
    };

    const onFinish = (values: any) => {
        let service = commaSeparatedString(servicesValue)
        const formData = {
            ...values,
            profilePic: profileFile,
            bannerPic: bannerFile,
            isSetupCompleted: false,
            services: service
        };
        localStorage.setItem('setupData', JSON.stringify( formData));
        handleSubmit(formData)
    };


  const handleCategoryChange = (value: string) => {
    if (value === 'other') {
      setIsOtherSelected(true);
    } else {
      setIsOtherSelected(false);
    }
  };


  useEffect(()=> {
    setProfilePic( profilePic || businessInfo?.logoUrl)
    setBannerPic( bannerPic || businessInfo?.bannerUrl)
    form.setFieldsValue({
        ...businessInfo,
        referUsURL: businessInfo?.referUsURL || businessInfo?.url,
        businessCategory: businessInfo?.category,
        businessDescription: businessInfo?.businessDescription || businessInfo?.description,
        // services: commaSeparatedString(servicesValue)
        // services: businessInfo?.services
    })
    // setServicesValue(businessInfo?.services?.split(', ')?.map((item: any) =>{ return { value: item}}))
  }, [businessInfo])

    useEffect(() => {
        setServicesValue(businessInfo?.services?.split(', ')?.map((item: any) => { return { value: item } }))
    }, [businessInfo?.services])


    const copyToClipboard = () => {
        navigator.clipboard.writeText(businessInfo?.url)
            .then(() => {
                message.success('Link copied to clipboard!');
            })
            .catch(err => {
                message.error('Failed to copy text: ' + err);
            });
    };

    const onFinishFailed =(value:any) => {
        console.log("onFinishFailed :::::::::", value)
        window.scrollTo(0,0)
    }

    return (
        <Form
            className="formControl"
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={{ ...businessInfo }}
        >
            <div className="uploadprofileimg">
                <Row>
                    <Col lg={8} sm={24}>
                        <div className=''>
                            <div className="profile-pic-container">
                                <img
                                    src={profilePic || imagbtns}
                                    alt="Profile"
                                    className="profile-pic"
                                    style={{ 
                                            // width: '372px',
                                            width: "-webkit-fill-available", 
                                            height: '170px', 
                                            borderRadius: '10px',
                                    }}
                                />
                            </div>
                            <input
                                type="file"
                                id="file-upload-profile"
                                accept=".jpg, .jpeg, .png" // Allow only JPG, JPEG, and PNG files
                                style={{ display: 'none' }} // Hide the 
                                onChange={(e) => handleImageChange(e, 'profile')}
                            />
                            <button 
                                type="button" 
                                onClick={() => triggerFileUpload('profile')} 
                                className="upload-button"
                                >
                                Upload Profile Image
                            </button>
                        </div>
                    </Col>
                    <Col lg={8} sm={24}>
                        <div className="textsides">
                            <h6>Business Logo</h6>
                            <p>The Image should be minimum ratio 2:1 (300x150) </p>
                            <p style={{ marginTop: '8px', color: '#888' }}>
                                Please upload an image file (JPG, JPEG, or PNG).
                            </p>
                        </div>
                    </Col>
                    <Col lg={8} sm={24}>
                        <p>Please resize your logo according to above dimensions
                            <a style={{ marginLeft: '10px', fontSize: '14px' }} title={`Link to resize your logo`} href='https://imageresizer.com/' target='_black'>Click Here</a>
                        </p>
                    </Col>
                </Row>

            </div>

            <Row gutter={16}>
                <Col lg={20} sm={24}>
                    <Form.Item
                        className="formControlDesign"
                        label="Name Of Business"
                        colon={false}
                        name="businessName"
                        rules={[
                            {
                                required: true,
                                message: 'Required.',
                                whitespace: true,
                            },
                        ]}
                    >
                        <Input value={businessInfo.businessName} />
                    </Form.Item>
                </Col>
                <Col lg={4} sm={24}>
                    <Form.Item
                        className="formControlDesign"
                        label="Background Color"
                        colon={false}
                        name="backgroundColor"
                    >
                        <ColorPicker
                            style={{ height: '49px', width: '100%' }}
                            size='large'
                            defaultValue={businessInfo?.backgroundColor}
                            showText
                            arrow
                            allowClear
                            onChange={(color:any)=> {
                                const hexString = `#${color?.metaColor?.r?.toString(16).padStart(2, '0')}${color?.metaColor?.g?.toString(16).padStart(2, '0')}${color?.metaColor?.b?.toString(16).padStart(2, '0')}`;
                                setBusinessInfo({
                                    ...businessInfo,
                                    backgroundColor: hexString
                                })
                            }}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item
                className="formControlDesign"
                label="ReferUs URL"
                name="referUsURL"
                rules={[{ required: true, message: 'Please add the name of your business.' }]}
            >
                <Input 
                    disabled
                    onChange={handleChange} 
                    name="referUsURL" 
                    value={businessInfo.referUsURL} 
                    suffix={
                        <Tooltip title="Click to copy">
                            <Button type="link" onClick={copyToClipboard}>
                                <CopyOutlined />
                            </Button>
                        </Tooltip>
                      }
                /> 
            </Form.Item>
            {/* <Button type="primary" icon={<CopyOutlined />} onClick={copyToClipboard}>Copy URL</Button>   */}

                <Form.Item
                    name="businessCategory"
                    label={<div>Business Category</div>}
                    className='formControlDesign'
                    rules={[
                        {
                            required: true,
                            message: 'Please select a business category!',
                        }
                    ]}
                >
                    {/* <Select
                        allowClear // Enable clear option
                        placeholder="Search and select a business category"
                        onChange={handleCategoryChange}
                        showSearch
                        filterOption={(input: any, option: any) => {
                                return option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                        }
                        options={updatedBusinessServiceList}
                    /> */}
                    <Select
                        placeholder="Business Category"
                        onChange={handleCategoryChange}
                        showSearch
                        filterOption={(input: any, option: any) => {
                                return option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                        }
                    >
                        {businessCategory?.map((item: any, index: number) => {
                            return <Select.Option key={index} value={item?.value}>{item?.label}</Select.Option>
                        })}
                    </Select>
                </Form.Item>

                  {isOtherSelected && (
                    <Form.Item
                      name="otherBusinessCategory" // Updated to use the same name
                      rules={[
                        {
                          required: true,
                          message: 'Please specify your business category!',
                        },
                      ]}
                    >
                      <Input placeholder="Specify other business category" />
                    </Form.Item>
                  )}

            <Form.Item
                name="businessDescription"
                label="Describe your Business"
                className="formControlDesign"
                rules={[{ required: true, message: 'Required.' }]}
            >
                <TextArea onChange={handleChange} name="businessDescription" rows={4} value={businessInfo.businessDescription} />
            </Form.Item>

            <Form.Item
                name="services"
                label="Your Services (Only 120 Characters allowed)"
                colon={false}
                className="formControlDesign"
            >
                <DynamicInputBox servicesValue={servicesValue} businessInfo={businessInfo} setServicesValue={setServicesValue}/>
            </Form.Item>

            <div className="text-end btn-groups-Forms">
                <button className="btn btn-outline-primary">Cancel</button>
                <button className="btn btn-primary" type="submit">
                   Save & Next
                </button>
            </div>
        </Form>
    );
};
